import { Dispatch, SetStateAction } from "react";

import terrible from "../../img/terrible.png";
import bad from "../../img/bad.png";
import regular from "../../img/regular.png";
import good from "../../img/good.png";
import excellent from "../../img/excellent.png";
import { StoreTotemProps } from "models/StoreTotem";
export interface CustomerScoreProps {
  setCustomerResponseScore: Dispatch<SetStateAction<string>>;
}
export interface CustomerFeedbackProps {
  setCustomerResponseFeedback: Dispatch<SetStateAction<string>>;
  customerResponseFeedback: string;
  sendCustomerDataCollection: (noOption?: boolean) => void;
  dataStoreTotem: StoreTotemProps | undefined;
}
export interface ScoreProps {
  img: string;
  text: string;
  handleCustomerScore: (value: string) => void;
}
export interface ButtonFeedbackProps {
  textBtn: string;
  handleFeedback: Function;
}

export const allScores = [
  {
    score: "PÉSSIMO",
    img: bad
  },
  {
    score: "RUIM",
    img: terrible
  },
  {
    score: "REGULAR",
    img: regular
  },
  {
    score: "BOM",
    img: good
  },
  {
    score: "ÓTIMO",
    img: excellent
  }
];

export const allFeedbacks: string[] = [
  'Preço',
  'Atendimento',
  'Disponibilidade de Produtos',
  'Qualidade da Mercadoria'
];

export const lowScoreEmoticons: string[] = [
  'PÉSSIMO',
  'RUIM',
  'REGULAR'
];